import { ServiceType } from "@agroyaar/sdk";

export function reportColor(serviceType: ServiceType): string {
  const colorMap: Partial<Record<ServiceType, string>> = {
    CROPPING_PATTERN: "#460F81",
  };

  return colorMap[serviceType] ?? "#460F81";
}

export function reportBackgroundColor(serviceType: ServiceType): string {
  const colorMap: Partial<Record<ServiceType, string>> = {
    CROPPING_PATTERN: "linear-gradient(45deg, #460F81, #007e8f00)",
  };

  return colorMap[serviceType] ?? "linear-gradient(45deg, #460F81, #007e8f00)";
}

export function dividerColor(serviceType: ServiceType): string {
  const colorMap: Partial<Record<ServiceType, string>> = {
    CROPPING_PATTERN: "linear-gradient(90deg, #e4451900, #460F81, #e4451900)",
  };

  return (
    colorMap[serviceType] ??
    "linear-gradient(90deg, #e4451900, #460F81, #e4451900)"
  );
}

function lightenColor(hex: string, alpha: number): string {
  const cleanHex = hex.replace("#", "");
  const alphaHex = Math.round(alpha * 255)
    .toString(16)
    .padStart(2, "0")
    .toUpperCase();

  return `#${cleanHex}${alphaHex}`;
}

export function getLightShades(serviceType: ServiceType) {
  const baseColor = reportColor(serviceType);

  return {
    baseColor,
    normal: lightenColor(baseColor, 0.75),
    light: lightenColor(baseColor, 0.5),
    lighter: lightenColor(baseColor, 0.15),
  };
}
